import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SaibaMaisComponent } from './saiba-mais.component';

@NgModule({
  imports: [CommonModule, FormsModule, PopoverModule.forRoot()],
  declarations: [SaibaMaisComponent],
  exports: [SaibaMaisComponent]
})
export class SaibaMaisModule {}
